const MS_IN_SECOND = 1000
const SECONDS_IN_HOUR = 3600

// DS-local copy of the app-level `convertSecondsToTime` — the DS layer sits below core and
// may not import it, and the cursor label is recomputed on every pointer move.
export const formatSeconds = (seconds: number): string => {
    if (!Number.isFinite(seconds) || seconds < 0) {
        return '00:00'
    }

    const iso = new Date(seconds * MS_IN_SECOND).toISOString()

    return seconds < SECONDS_IN_HOUR ? iso.substring(14, 19) : iso.substring(11, 19)
}
